/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProjectVM { 
    id?: number;
    isActive?: boolean | null;
    name?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    country?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    notes?: string | null;
    createdBy?: number;
    updatedBy?: number;
    createdByName?: string | null;
    koboSelectSchool?: string | null;
    hasAnalytics?: boolean;
    hasReadingCamp?: boolean;
    hasParticipations?: boolean;
    hasDocuments?: boolean;
    hasDevices?: boolean;
    hasContacts?: boolean;
}

